import { safeParseJson, toApiError } from "@/lib/api/client"
import { type ForgotPasswordValues, type ResetPasswordValues } from "@/lib/password/schemas"

async function request(path: string, method: "POST" | "PUT", body: unknown): Promise<void> {
  const response = await fetch(path, {
    method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
    cache: "no-store",
  })
  if (!response.ok) throw toApiError(safeParseJson(await response.text()), response.status)
}

export function requestPasswordReset(values: ForgotPasswordValues): Promise<void> {
  return request("/api/auth/password", "POST", { user: { email: values.email } })
}

export function resetPassword(token: string, values: ResetPasswordValues): Promise<void> {
  return request("/api/auth/password", "PUT", {
    user: { reset_password_token: token, password: values.password, password_confirmation: values.passwordConfirmation },
  })
}
